import { connect } from 'react-redux'

import { MenuItemUpdates } from '@components/chefNetwork'
import coordinators from '@coordinators'
import services from '@services'
import { HandleError } from '@coordinators/composed'

const mapStateToProps = () => undefined

//Admin changes
const mapDispatchToProps = () => {
  const { RestService, UIService } = services
  const {
    LoadMenuItemUpdates,
    LoadNewMenuItems,
    ChefNetworkBulkCompleteItemUpdate,
    ChefNetworkBulkCompleteNewItem,
    ChefNetworkCompletedItemUpdate,
    ChefNetworkCreatedNewItem,
    ChefNetworkDeletedCreateRequest,
    ChefNetworkDeletedUpdateRequest,
    ChefNetworkSaveMenuItemImage,
    ChefNetworkUpdateItemRequest,
  } = coordinators
  const loadMenuItemUpdates = LoadMenuItemUpdates({
    RestService,
    HandleError,
  })

  const loadNewMenuItems = LoadNewMenuItems({
    RestService,
    HandleError,
  })

  const chefNetworkCompletedItemUpdate = ChefNetworkCompletedItemUpdate({
    RestService,
    HandleError,
  })

  const chefNetworkBulkCompleteItemUpdate = ChefNetworkBulkCompleteItemUpdate({
    RestService,
    UIService,
  })

  const chefNetworkBulkCompleteNewItem = ChefNetworkBulkCompleteNewItem({
    RestService,
    UIService,
  })

  const chefNetworkCreatedNewItem = ChefNetworkCreatedNewItem({
    RestService,
    HandleError,
  })

  const chefNetworkDeletedCreateRequest = ChefNetworkDeletedCreateRequest({
    RestService,
    HandleError,
  })

  const chefNetworkDeletedUpdateRequest = ChefNetworkDeletedUpdateRequest({
    RestService,
    HandleError,
  })

  const chefNetworkSaveMenuItemImage = ChefNetworkSaveMenuItemImage({
    RestService,
    HandleError,
  })

  const chefNetworkUpdateItemRequest = ChefNetworkUpdateItemRequest({
    RestService,
    HandleError,
  })

  return {
    chefNetworkCreatedNewItem,
    chefNetworkBulkCompleteItemUpdate,
    chefNetworkBulkCompleteNewItem,
    chefNetworkCompletedItemUpdate,
    chefNetworkDeletedCreateRequest,
    chefNetworkDeletedUpdateRequest,
    chefNetworkSaveMenuItemImage,
    chefNetworkUpdateItemRequest,
    loadNewMenuItems,
    loadMenuItemUpdates,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MenuItemUpdates)
